import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/tmp/37da04a9/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <AnchorLinks mdxType="AnchorLinks">
      <AnchorLink mdxType="AnchorLink">Introduction</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Guiding principles</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Who is Carbon for?</AnchorLink>
      <AnchorLink mdxType="AnchorLink">Internal IBM info</AnchorLink>
    </AnchorLinks>
    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <p>{`Carbon is IBM’s open-source design system for digital products and experiences. With the IBM Design Language as its foundation, the system consists of working code, design tools and resources, human interface guidelines, and a vibrant community of contributors.`}</p>
    <p>{`As IBM’s official design system, Carbon serves a wide range of designers and developers building digital products and experiences. The goals of the system include improving UI consistency and quality, making the design and development process more efficient and focused, establishing a shared vocabulary between designer and developer, and providing clear, discoverable guidance around design and development best practices.`}</p>
    <p>{`Carbon is maintained by a core team of designers, developers, and writers based in the Austin, Texas IBM Design Studio.`}</p>
    <h2 {...{
      "id": "guiding-principles"
    }}>{`Guiding principles`}</h2>
    <h4 {...{
      "id": "carbon-is-open"
    }}>{`Carbon is open`}</h4>
    <p>{`It’s a distributed effort, guided by the principles of the `}<a parentName="p" {...{
        "href": "https://en.wikipedia.org/wiki/Open-source-software_movement"
      }}>{`open-source movement`}</a>{`. Carbon’s users are also its makers, and everyone is encouraged to contribute.`}</p>
    <h4 {...{
      "id": "carbon-is-inclusive"
    }}>{`Carbon is inclusive`}</h4>
    <p>{`It’s designed and built to be accessible to all, regardless of ability or situation.`}</p>
    <h4 {...{
      "id": "carbon-is-modular-and-flexible"
    }}>{`Carbon is modular and flexible`}</h4>
    <p>{`Carbon’s modularity ensures maximum flexibility in execution. Its components are designed to work seamlessly with each other, in whichever combination suits the needs of the user.`}</p>
    <h4 {...{
      "id": "carbon-puts-the-user-first"
    }}>{`Carbon puts the user first`}</h4>
    <p>{`Starting with rigorous research into users’ needs and desires, and revised continuously based on their feedback, Carbon is laser-focused on real people.`}</p>
    <h4 {...{
      "id": "carbon-builds-consistency"
    }}>{`Carbon builds consistency`}</h4>
    <p>{`Based on the comprehensive IBM Design Language, every element and component of Carbon was designed from the ground up to work elegantly together to ensure consistent, cohesive user experiences.`}</p>
    <h2 {...{
      "id": "who-is-carbon-for"
    }}>{`Who is Carbon for?`}</h2>
    <h4 {...{
      "id": "designers"
    }}>{`Designers`}</h4>
    <p>{`Carbon is the official implementation of the IBM Design Language for product and web designers, and represents an ever-growing ecosystem of design assets and guidance. With a comprehensive set of human interface guidelines, design kits, and documentation, Carbon helps designers work faster and smarter.`}</p>
    <h4 {...{
      "id": "developers"
    }}>{`Developers`}</h4>
    <p>{`Carbon is built by developers, for developers. Our front-end libraries are continuously maintained and fully supported by the core Carbon team (and an army of open-source contributors).`}</p>
    <p>{`There are four different implementations of the Carbon Design System. One is a vanilla JavaScript library; that’s written in ES6+, SCSS, and HTML and ships deliverables in vanilla JavaScript in ES5 as well as ES6, CSS, SCSS and HTML. Another is a React library that ships a React rewrite of the JavaScript, but uses the same CSS as the core library. There are also Angular and Vue libraries that uses the same CSS.`}</p>
    <h2 {...{
      "id": "internal-ibm-info"
    }}>{`Internal IBM info`}</h2>
    <h4 {...{
      "id": "coo-approvals"
    }}>{`COO approvals`}</h4>
    <p>{`Carbon v10.x`}</p>
    <ul>
      <li parentName="ul">{`COO record ID: 95607540`}</li>
      <li parentName="ul">{`COO reference number: COO20190204`}</li>
      <li parentName="ul">{`Name of IBM material (with version number): IBM Design System `}{`[Version 10, Release n/a, Modification n/a]`}</li>
      <li parentName="ul">{`Last release date: March 31, 2019`}</li>
      <li parentName="ul">{`Name of Product/Program manager or author of material: Daniel Kuehn/Austin/IBM`}</li>
    </ul>
    <p>{`Carbon v9.x`}</p>
    <ul>
      <li parentName="ul">{`COO number of IBM material (if any): `}<em parentName="li">{`AUS720180239`}</em></li>
      <li parentName="ul">{`Name of IBM material (with version number): `}<em parentName="li">{`IBM Design System `}{`[Version 9, Release n/a, Modification n/a]`}</em></li>
      <li parentName="ul">{`Last release date: `}<em parentName="li">{`June 4, 2018`}</em></li>
      <li parentName="ul">{`Name of Product/Program manager or author of material: `}<em parentName="li">{`DanielKuehn/Austin/IBM`}</em></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      